import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "rs-version",
  templateUrl: "./version.component.html",
  standalone: true,
})
export class VersionComponent {
  get internalVersion(): string {
    return environment.internalVersion;
  }
}
